import React from 'react'
import {ResultsTableProps} from './types'
import ResultsTableView from './ResultsTableView'


const ResultsTable = (props: ResultsTableProps) => <ResultsTableView {...props} />

export default ResultsTable
